import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { ScrollIndicator } from '@/teams/portfolio/components/scroll-indicator/scroll-indicator.tsx'
import { Section } from '@/teams/portfolio/components/section/section/section.tsx'
import { SkillCard } from '@/teams/portfolio/components/section/skills-section/skill-card/skill-card.tsx'
import { skillCards } from '@/teams/portfolio/components/section/skills-section/skills-data.ts'
import { VisualShowcase } from '@/teams/portfolio/components/section/skills-section/visual-showcase/visual-showcase.tsx'
import '@/teams/portfolio/components/section/skills-section/skills-section.scss'

export function SkillsSection() {
	const { t } = useTranslation()

	const titleId = 'skills-section-title'
	const sectionTitle = t('portfolio.section.skills.title.v1')

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for URL anchor navigation
		<Section ariaLabel={t('portfolio.section.skills.ariaLabel')} id='skills'>
			<div className='skills-section'>
				<h2 className='skills-section__title' id={titleId}>
					{sectionTitle}
					<span
						aria-hidden='true'
						className='skills-section__title-underline'
					/>
				</h2>
				<div className='skills-section__rows'>
					{skillCards.map((card, index) => {
						const isReversed = index % 2 !== 0

						return (
							<div
								className={`skills-section__row${isReversed ? ' skills-section__row--reversed' : ''}`}
								key={card.id}>
								<div className='skills-section__card'>
									<SkillCard card={card} />
								</div>
								<div className='skills-section__panel'>
									<VisualShowcase
										altKey={card.showcaseAltKey}
										imageSrc={card.showcaseImage}
									/>
								</div>
							</div>
						)
					})}
				</div>

				<ScrollIndicator targetSection='experience' />
			</div>
		</Section>
	)
}
